import {
  NavigationDesktopDropdown,
  NavigationDesktopLink,
} from '@retainerclub/common';
import { useApp } from '@retainerclub/hooks';
import { NavLink } from 'react-router';
import { accountNav } from './helpers/navLinks';

function DesktopNavAuthed() {
  const { isCustomer } = useApp();

  return isCustomer ? (
    <div className="hidden lg:flex lg:gap-x-12">
      <NavigationDesktopLink to="/" title="Dashboard" />
      <NavigationDesktopLink to="/shop" title="Shop" />
      <NavigationDesktopLink to="/my-orders" title="Orders" />
      <NavigationDesktopDropdown menuItems={accountNav} title="Account" />
    </div>
  ) : (
    <div className="hidden lg:flex lg:gap-x-12">
      <NavLink
        to="/"
        className="font-normal text-gray-900 text-sm leading-6 hover:text-rcprimary-400 hover:underline"
      >
        Home
      </NavLink>
      <a
        href="https://locator.retainerclub.com"
        className="font-normal text-gray-900 text-sm leading-6 hover:text-rcprimary-400 hover:underline"
      >
        Doctor Locator
      </a>
      <a
        href="https://retainerclub.com/why-replace-retainers"
        className="font-normal text-gray-900 text-sm leading-6 hover:text-rcprimary-400 hover:underline"
      >
        Why Replace Retainers?
      </a>
      <a
        href="https://retainerclub.com/support"
        className="font-normal text-gray-900 text-sm leading-6 hover:text-rcprimary-400 hover:underline"
      >
        Support
      </a>
    </div>
  );
}

export default DesktopNavAuthed;
